var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-space-text"},[_vm._v("Um den Tarifwechsel zu nutzen erstelle bitte zuerst ein Objekt im Dashboard")])
}
var staticRenderFns = []

export { render, staticRenderFns }